<template>
	<div class="primary-secondary-btn-wrapper">
		<v-btn
			class="mr-4 btn--primary-alturos-blue"
			@click="confirm"
		> 
			{{ labelPrimaryAction }}
		</v-btn>
		<v-btn
			class="mr-4"
			color="secondary"
			@click="reject"
		>
			{{ labelSecondaryAction }}
		</v-btn>
	</div>
</template>

<script>
export default {
	props: {
		labelPrimaryAction: {
			type: String,
			default: 'Yes',
		},
		labelSecondaryAction: {
			type: String,
			default: 'No',
		}
	},
	data() {
		return {
			//	
		}
	},
	methods: {
		confirm() {
			this.$emit('confirmed')
		},
		reject() {
			this.$emit('rejected')
		}
	}
}

</script>

<style lang="scss">
@import '../../../src/assets/scss/styling';

.primary-secondary-btn-wrapper {
	padding: 10px 0 0 0 ;
	.btn {
		&--primary-alturos-blue {
			background-color: $alturos-blue !important;
			color: $white !important;
		}
	}
}

</style>